// Ported from genieos/web/src/components/historian/VariableBrowserSkeleton.tsx @ 84923d036
/**
 * Variable Browser Skeleton Component
 *
 * Loading skeleton for the variable browser tree view.
 * Displays placeholder content while schema is loading.
 */

import React from 'react';
import { cn } from '@/utils/cn';

interface VariableBrowserSkeletonProps {
  className?: string;
}

export const VariableBrowserSkeleton: React.FC<VariableBrowserSkeletonProps> = ({
  className,
}) => {
  return (
    <div
      className={cn('p-3 space-y-4 animate-pulse', className)}
      aria-hidden="true"
      role="presentation"
    >
      {/* Search skeleton */}
      <div className="h-10 bg-ems-bg-card-hover rounded-lg" />

      {/* Tree skeletons */}
      {[1, 2, 3, 4].map((i) => (
        <div key={i} className="space-y-2">
          {/* Supertable row */}
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 bg-ems-bg-card-hover rounded" />
            <div className="w-4 h-4 bg-ems-bg-card-hover rounded" />
            <div
              className="h-5 bg-ems-bg-card-hover rounded"
              style={{ width: `${80 + Math.random() * 60}px` }}
            />
            <div className="ml-auto w-16 h-4 bg-ems-bg-card-hover rounded" />
          </div>

          {/* Device rows (only show for first two) */}
          {i <= 2 && (
            <div className="ml-6 space-y-2">
              {[1, 2].map((j) => (
                <div key={j} className="flex items-center gap-2">
                  <div className="w-3 h-3 bg-ems-bg-card-hover rounded" />
                  <div className="w-3.5 h-3.5 bg-ems-bg-card-hover rounded" />
                  <div
                    className="h-4 bg-ems-bg-card-hover rounded"
                    style={{ width: `${60 + Math.random() * 40}px` }}
                  />
                </div>
              ))}
            </div>
          )}
        </div>
      ))}

      {/* Footer skeleton */}
      <div className="pt-4 border-t border-ems-border">
        <div className="h-4 w-32 bg-ems-bg-card-hover rounded" />
      </div>
    </div>
  );
};

export default VariableBrowserSkeleton;
